import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "pa-4 ion-text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "body-2 o-7" }, " Sorry, no resources were found. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.resources && _ctx.resources.length > 0)
      ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                button: "",
                key: resource.id + 'resource',
                class: "ma-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_avatar, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        size: "large",
                        icon: _ctx.documentOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(resource.title), 1),
                      (resource.file)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(resource.file.ext) + " " + _toDisplayString((resource.file.size / 1000).toFixed(2)) + " MB ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("a", {
                    slot: "end",
                    href: resource.file.url,
                    download: "",
                    target: "_blank"
                  }, [
                    _createVNode(_component_ion_button, {
                      class: "auto my-pointer mr-2",
                      icon: "",
                      fill: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.openOutline,
                          size: "large"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && (!_ctx.resources || _ctx.resources.length == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ion_icon, {
            button: "",
            color: "primary",
            class: "auto pa-4 o-7",
            size: "large",
            icon: _ctx.thumbsDownOutline
          }, null, 8, ["icon"]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ], 64))
}